import { createStore } from 'vuex';
//import LocalDataService from '../services/LocalDataService';
import { DataServices } from '../services/DataServices';
import { FirebaseDataService } from '../services/FirebaseDataServices';

//const LocalJSONDataServices = new LocalDataService();

export default createStore({
  state: {
    Mode: 'PC',
    viewMode: 'DAY',
    daySchedule: [],
    dayScheduleSlide: [],
    onceDaySchedulePrint: [],
    monthSchedule: [],
    isLoad: false,
  },
  mutations: {
    SET_MODE(state, payload) {
      state.Mode = payload;
    },
    SET_VIEWMODE(state, payload) {
      state.viewMode = payload;
    },
    SET_DAYSCHEDULE(state, payload) {
      state.daySchedule = payload;
    },
    SET_DAYSCHEDULESLIDE(state, payload) {
      state.dayScheduleSlide = payload;
    },
    SET_MONTHSCHEDULE(state, payload) {
      state.monthSchedule = payload;
    },
    SET_ISLOAD(state, payload) {
      state.isLoad = payload;
    },
    SET_ONCEDAYSCHEDULEPRINT(state, payload) {
      state.onceDaySchedulePrint = payload;
    },
  },
  actions: {
    ChangeViewMode({ commit }, payload) {
      commit('SET_VIEWMODE', payload);
    },
    ChangeMode({ commit }, payload) {
      commit('SET_MODE', payload);
    },
    async dayScheduleLoad({ commit }) {
      commit('SET_ISLOAD', true);
      commit('SET_DAYSCHEDULE', []);
      let data = await FirebaseDataService.getOnceNow();
      let RestructureData =
        await DataServices.scheduleStructure_day_back(data);
      commit('SET_DAYSCHEDULE', RestructureData);
      setInterval(function () {
        commit('SET_ISLOAD', false);
        clearInterval();
      }, 3000);
      //commit('SET_DAYSCHEDULE', data);
    },
    async dayScheduleLoadSpacificDay({ commit }, payload) {
      commit('SET_ISLOAD', true);
      commit('SET_DAYSCHEDULE', []);
      let data = await FirebaseDataService.getOnceSpacificDay(
        payload,
      );
      let RestructureData =
        await DataServices.scheduleStructure_day_back_spa(
          data,
          payload,
        );
      commit('SET_DAYSCHEDULE', RestructureData);
      setInterval(function () {
        commit('SET_ISLOAD', false);
        clearInterval();
      }, 3000);
      //commit('SET_DAYSCHEDULE', data);
    },
    async monthScheduleLoad({ commit }) {
      let data = await FirebaseDataService.getOnceMonth();
      let RestructureData =
        await DataServices.scheduleStructure_month_back(data);
      commit('SET_MONTHSCHEDULE', RestructureData);
    },
    async onceDaySchedulePrintLoad({ commit }, payload) {
      commit('SET_ISLOAD', true);
      commit('SET_ONCEDAYSCHEDULEPRINT', []);
      let data = await FirebaseDataService.getOnceSpacificDay(
        payload,
      );
      let RestructureData =
        await DataServices.scheduleStructure_day_back_spa(
          data,
          payload,
        );
      commit('SET_ONCEDAYSCHEDULEPRINT', RestructureData);
      setInterval(function () {
        commit('SET_ISLOAD', false);
        clearInterval();
      }, 3000);
      //commit('SET_DAYSCHEDULE', data);
    },
    async dayScheduleSlideLoad({ commit }) {
      commit('SET_ISLOAD', true);
      //commit('SET_DAYSCHEDULE', []);
      let data = await FirebaseDataService.getOnceNow();
      let RestructureData =
        await DataServices.scheduleStructure_day_back(data);
      commit('SET_DAYSCHEDULE', RestructureData);
      setInterval(function () {
        commit('SET_ISLOAD', false);
        clearInterval();
      }, 3000);

      /*let SlideRestructureData =
        await DataServices.scheduleStructure_day_Slide(
          RestructureData,
        );
      commit('SET_DAYSCHEDULESLIDE', SlideRestructureData);*/

      let SlideRestructureData =
        await DataServices.scheduleStructure_day_Slide_optional(
          RestructureData,
        );
      commit('SET_DAYSCHEDULESLIDE', SlideRestructureData);
    },
  },
});
